import { Message } from 'semantic-ui-react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ReviewFlowSettings } from 'page-components/question-threads'
import { getTemplatePermissions } from 'utility'
import { AuthService } from 'utility/services/auth'

// The review-settings API takes the NUMERIC template id (same lesson as the approval workflow page, 2026-10-22).
const numericTemplateId = (param, state) => {
    if (/^\d+$/.test(String(param || ''))) return String(param)
    const fromState = state?.templateNumericId
    return /^\d+$/.test(String(fromState || '')) ? String(fromState) : null
}

export const TemplateReviewFlowScreen = () => {
    const { templateId } = useParams()
    const location = useLocation()
    const navigate = useNavigate()
    const resolvedId = numericTemplateId(templateId, location.state)
    const onBack = () => navigate('/app/templates')
    const { canEditTemplate } = getTemplatePermissions(AuthService.getUser())

    if (!canEditTemplate || !resolvedId) {
        return (
            <Message warning>
                <Message.Header>Review flow</Message.Header>
                <p>
                    {!canEditTemplate
                        ? 'Only admins and template managers can change the review flow.'
                        : 'Open the review flow from the Templates list (template menu > Review flow).'}
                </p>
                <button type="button" className="ui button" onClick={onBack}>
                    Back to templates
                </button>
            </Message>
        )
    }

    return (
        <ReviewFlowSettings
            key={resolvedId}
            templateId={resolvedId}
            templateName={location.state?.templateName || ''}
            onBack={onBack}
        />
    )
}
